'use strict';

var processInclude = require('base/util');
const { queryFirst, removeClass } = require('./domUtil');
const { INVISIBLE_CLASS } = require('./constants');

document.addEventListener('DOMContentLoaded', () => {
    processInclude(require('./category/shopByStyle'));
    processInclude(require('./category/shopByPrint'));
    updateContentElements();
});

/**
 * This method updates the page H1 tag and banner header & text of the email capture asset for the seasonal pages.
 */
function updateContentElements() {
    const contentElement = queryFirst('.seasonal-landing-page');
    const headerElement = queryFirst('.dynamic-email-capture-title .plp-title');
    const bannerHeaderElement = queryFirst('.seasonal-banner-header', contentElement);
    const bannerTextElement = queryFirst('.seasonal-banner-title', contentElement);
    const categoryNameElement = queryFirst('.category-display-name');
    if (headerElement && bannerHeaderElement && bannerTextElement && categoryNameElement) {
        headerElement.innerHTML = categoryNameElement.value;
        bannerHeaderElement.innerHTML = categoryNameElement.value;
        bannerTextElement.innerHTML = categoryNameElement.value;
        removeClass(headerElement, INVISIBLE_CLASS);
        removeClass(bannerHeaderElement, INVISIBLE_CLASS);
        removeClass(bannerTextElement, INVISIBLE_CLASS);
    }
}
